/**
 * Parses a YYYY-MM-DD date string as local noon to prevent date shifting in UTC-negative timezones.
 *
 * new Date("YYYY-MM-DD") is parsed as UTC midnight per the ES spec, which causes date-fns
 * format() to render the previous calendar day for users in UTC-negative timezones (e.g. US).
 * Appending 'T12:00:00' creates a local noon Date that stays on the correct calendar day
 * in any timezone from UTC-11 to UTC+12.
 *
 * @param {string} dateStr - A YYYY-MM-DD date string.
 * @returns {Date}
 */
export function parseDateString(dateStr) {
  return new Date(`${dateStr}T12:00:00`);
}

/**
 * Convert minutes to formatted hour
 *
 * For example:
 * 30 -> 30 min
 * 60 -> 1 hr
 * 90 -> 1.5 hr
 *
 * @param {number} minute
 * @returns {string}
 */
export function formatFromMinuteToFormattedHour(minute) {
  if (minute < 60) {
    return `${minute} min`;
  }

  const hour = minute / 60;
  return `${hour} hr`;
}
